import Dropdown from 'components/Dropdown'
import ModalContext from 'containers/ModalManager/ModalContext'
import { ShareListItemFragment } from 'gqlTypes'
import { DownloadProps } from 'modules/shares/utils'
import React, { FC, useContext } from 'react'
import { RestoreShareModal } from 'modules/shares/components/RestoreShareModal'
import { DeleteSharePermanentlyModal } from 'modules/shares/components/DeleteSharePermanentlyModal'

import { canRestoreShare } from '../../utils'

export interface ShareForTrashedActionsDropdown
  extends Pick<
    ShareListItemFragment,
    'userAccessLevel' | 'workspace' | 'name' | 'identifier' | 'project'
  > {}

interface ShareTrashedActionsDropdownProps {
  share: ShareForTrashedActionsDropdown
  download: DownloadProps
  isUserAdmin: boolean
}

export const ShareTrashedActions: FC<ShareTrashedActionsDropdownProps> = props => {
  const { showModal } = useContext(ModalContext)
  const { share, download, isUserAdmin } = props

  const shareName = share.name
  const shareIdentifier = share.identifier
  const isInDraftsProject = share.project?.type === 'PERSONAL_DRAFTS'

  return (
    <>
      {download?.isAvailable && (
        <Dropdown.Download href={download.url}>Download</Dropdown.Download>
      )}
      {(canRestoreShare(share) || isUserAdmin) && (
        <>
          <Dropdown.Item
            onClick={() =>
              showModal(RestoreShareModal, {
                name: shareName,
                shareIdentifier,
                isInDraftsProject,
              })
            }>
            Restore&hellip;
          </Dropdown.Item>

          <Dropdown.Divider />
          <Dropdown.Item
            intent="negative"
            onClick={() =>
              showModal(DeleteSharePermanentlyModal, {
                name: shareName,
                shareIdentifier,
                workspaceId: share.workspace!.identifier,
              })
            }>
            Delete Permanently&hellip;
          </Dropdown.Item>
        </>
      )}
    </>
  )
}
